import { render, staticRenderFns } from "./SalaryAudit.vue?vue&type=template&id=4403e9fe&scoped=true"
import script from "./SalaryAudit.vue?vue&type=script&lang=js"
export * from "./SalaryAudit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4403e9fe",
  null
  
)

export default component.exports